import { toast } from "vue3-toastify";

export const ERROR_TOAST_AUTO_CLOSE = 8000;

export const showErrorToast = (message, options = {}) =>
  toast(message, {
    type: "error",
    theme: "colored",
    transition: toast.TRANSITIONS.SLIDE,
    position: toast.POSITION.BOTTOM_RIGHT,
    autoClose: ERROR_TOAST_AUTO_CLOSE,
    ...options,
  });
